<script>
  // Heroicons, hand-thumb-down, outline
  export let iconClass = '';
</script>

<svg xmlns="http://www.w3.org/2000/svg" title="Dislike" fill="none" viewBox="0 0 16 16" stroke-width="1.5" stroke="currentColor" class={`w-4 h-4 ${iconClass}`}>
  <title>Dislike</title>
  <path d="M10.325 3H12v5c-.663 0-1.219.466-1.557 1.037a4.02 4.02 0 0 1-1.357 1.377c-.478.292-.907.706-.989 1.26v.005a9.031 9.031 0 0 0 0 2.642c.028.194-.048.394-.224.479A2 2 0 0 1 5 13c0-.812.08-1.605.234-2.371a.521.521 0 0 0-.5-.629H3C1.896 10 .99 9.102 1.1 8.003A19.827 19.827 0 0 1 2.18 3.215C2.45 2.469 3.178 2 3.973 2h2.703a2 2 0 0 1 .632.103l2.384.794a2 2 0 0 0 .633.103ZM14 2a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1Z" />
</svg>